// src/core/wbk/queue/sessionCookie.ts
var QUEUE_SESSION_COOKIE = "queue_session";
var getQueueSessionCookieName = (slug) => `${QUEUE_SESSION_COOKIE}_${encodeURIComponent(slug)}`;

export {
  getQueueSessionCookieName
};
//# sourceMappingURL=chunk-G2X2IF27.mjs.map